import React from 'react';

import MainHero from '../../components/Hero';

const Title = () => (
  <>
    Email Studio for&nbsp;
    <span className="text-white">Gmail</span>
  </>
);

const Hero = () => {
  return (
    <MainHero
      isProduct
      title={<Title />}
      button1={{
        text: 'Launch',
        title: 'Launch Email Studio for Gmail',
        href: 'https://emailstudio.pro',
      }}
      button2={{
        text: 'Upgrade',
        title: 'Go premium and unlock all features!',
        href: '#pricing',
      }}
    >
      Adds power tools to Gmail including Recurring Scheduler, Forwarder, Smart
      Auto-Responder and Email Archiver.
    </MainHero>
  );
};

export default Hero;
